import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Link from '../Link';
const CTAsList = ({ CTAs, nested }) => {
    if (!(CTAs === null || CTAs === void 0 ? void 0 : CTAs.length)) {
        return null;
    }
    return (_jsx(_Fragment, { children: CTAs.map((link, index) => (_jsx(Link, Object.assign({}, link, { nested: nested }), index))) }));
};
export default CTAsList;
